export const CORPORATE_DOCUMENT_FIELDS = [
  {
    key: "certificateOfIncorporation",
    payloadKey: "CertificateOfIncorporation",
    title: "Certificate of Incorporation",
    instruction:
      "Please attach a colour copy of your Certificate of Incorporation.",
    accent: "#7367F0",
    documentType: 3,
    documentSubType: 5,
    required: true,
  },
  {
    key: "constitutionMemorandumArticles",
    payloadKey: "ConstitutionMemorandumArticles",
    title: "Constitution / Memorandum and Articles of Association",
    instruction:
      "Please attach your company's Constitution, Memorandum and Articles of Association.",
    accent: "#28C76F",
    documentType: 4,
    documentSubType: 11,
    required: true,
  },
  {
    key: "registerOfDirectors",
    payloadKey: "RegisterOfDirectors",
    title: "Register of Directors",
    instruction:
      "Please attach an up-to-date Register of Directors for your company.",
    accent: "#FF9F43",
    documentType: 4,
    documentSubType: 12,
    required: true,
  },
  {
    key: "registerOfShareholders",
    payloadKey: "RegisterOfShareholders",
    title: "Register of Shareholders/Directors (min 20% ownership)",
    instruction:
      "Please attach the Register of Shareholders/Directors showing all parties with a minimum of 20% ownership.",
    accent: "#00CFE8",
    documentType: 4,
    documentSubType: 13,
    required: true,
  },
  {
    key: "latestAuditedFinancialStatement",
    payloadKey: "LatestAuditedFinancialStatement",
    title: "Latest Audited Financial Statement",
    instruction:
      "Please attach your company's latest audited financial statement.",
    accent: "#EA5455",
    documentType: 4,
    documentSubType: 14,
    required: true,
  },
  {
    key: "others",
    payloadKey: "Others",
    title: "Others",
    instruction:
      "Please attach any other supporting corporate documents, if applicable.",
    accent: "#A855F7",
    documentType: 4,
    documentSubType: 10,
    required: false,
  },
];

export const REQUIRED_CORPORATE_DOCUMENT_FIELDS = CORPORATE_DOCUMENT_FIELDS.filter(
  (doc) => doc.required !== false
);

export const CORPORATE_DOCUMENT_PAYLOAD_KEYS = CORPORATE_DOCUMENT_FIELDS.map(
  (doc) => doc.payloadKey
);

export const getCorporateDocumentFromResponse = (
  corporateDocuments,
  key,
  payloadKey
) => {
  const value =
    corporateDocuments?.[key] ??
    corporateDocuments?.[payloadKey] ??
    corporateDocuments?.[
      payloadKey.charAt(0).toLowerCase() + payloadKey.slice(1)
    ];

  if (Array.isArray(value)) return value[0] || null;
  if (value && typeof value === "object") return value;
  return null;
};

export const mapCorporateDocumentFromApi = (doc) => {
  if (!doc?.id && !doc?.fileUrlPath) return null;

  return {
    id: doc.id,
    fileUrlPath: doc.fileUrlPath,
    fileName: doc.fileName || doc.fileUrlPath?.split("/").pop(),
    status: doc.status || "PROCESSING",
    documentType: doc.documentType,
    documentSubType: doc.documentSubType,
  };
};
